import { render, staticRenderFns } from "./ToPay.vue?vue&type=template&id=5d33e7d8&scoped=true"
import script from "./ToPay.vue?vue&type=script&lang=js"
export * from "./ToPay.vue?vue&type=script&lang=js"
import style0 from "./ToPay.vue?vue&type=style&index=0&id=5d33e7d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d33e7d8",
  null
  
)

export default component.exports